const stats = [
  { icon: 'ri-star-fill', value: '4.9', label: '평균 평점', color: '#f59e0b' },
  { icon: 'ri-chat-smile-3-line', value: '500+', label: '누적 후기', color: '#2E7D6B' },
  { icon: 'ri-repeat-2-line', value: '92%', label: '재이용율', color: '#2E7D6B' },
  { icon: 'ri-thumb-up-line', value: '98%', label: '만족도', color: '#2E7D6B' },
];

export default function ReviewStats() {
  return (
    <section className="w-full py-14 bg-white border-t border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="flex flex-col items-center text-center py-4">
              <div
                className="w-12 h-12 flex items-center justify-center rounded-xl mb-3"
                style={{ backgroundColor: stat.color === '#f59e0b' ? '#fffbeb' : '#e8f5f1' }}
              >
                <i className={`${stat.icon} text-xl`} style={{ color: stat.color }}></i>
              </div>
              <p className="text-3xl md:text-4xl font-extrabold mb-1" style={{ color: '#1a2e29' }}>
                {stat.value}
              </p>
              <p className="text-sm text-gray-500">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
